import Axios, { AxiosObservable } from 'axios-observable';
import { CONFIG } from 'const/config';
import { DepartmentRolesServiceResponseInterfaceTypes } from 'types';

export const departmerntRolesService =
  (): AxiosObservable<DepartmentRolesServiceResponseInterfaceTypes> =>
    Axios.get(`${CONFIG.API_URL}/department_roles`, { params: { per: 100 } });
